/**
 * Common vuex store methods that are used by campaign actions
 * & published campaign actions
 */

import { convert24To12, convertDateTime } from '@/Core/filters/dates';
import { secondsToMinutes } from '@/Core/filters/times';

export const formatActionSchedule = action => {
  switch (action.timing_type) {
    case 'Delay by Day and Time': {
      const convertedTime = convert24To12(action.dispatch_time);
      action.schedule = `${action.delay_by_days} days later at ${convertedTime}`;
      break;
    }
    case 'Exact Date and Time': {
      const convertedDateTime = convertDateTime(action.dispatch_datetime);
      action.schedule = `${convertedDateTime}`;
      break;
    }
    case 'Recurring': {
      action.schedule = 'Recurring';
      break;
    }
    default: {
      const minutes = secondsToMinutes(action.delay_by_seconds);
      action.schedule = minutes ? `${minutes} minutes later` : 'Immediately';
    }

  }
};

export default {
  getters: {
    headers(state) {
      return state.headers.filter(header => {
        return header.text && header.text.length > 0;
      });
    },
    visibleFields(state) {
      return state.headers.filter(header => header.visible)
        .map(header => header.value);
    },
    /**
     * for fields where sorting is not as straight-forward
     * eg sorting on multiple fields
     */
    specialSorts(state) {
      const sortFields = {};
      state.headers.forEach(header => {
        if (header.sortByColumns) {
          sortFields[header.value] = header.sortByColumns;
        }
      });
      return sortFields;
    },
  },
};
